import { render, staticRenderFns } from "./obligation-modal.vue?vue&type=template&id=1104b548&"
import script from "./obligation-modal.vue?vue&type=script&lang=js&"
export * from "./obligation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports